/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Storage_DescriptionInputs */

const es_settings_storage_description = /** @type {(inputs: Settings_Storage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestioná qué archivos y carpetas puede utilizar Nexata para analizar, buscar y contextualizar información.`)
};

const en_settings_storage_description = /** @type {(inputs: Settings_Storage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage which files and folders Nexata can analyze, search, and use for contextual information.`)
};

/**
* | output |
* | --- |
* | "Manage which files and folders Nexata can analyze, search, and use for contextual information." |
*
* @param {Settings_Storage_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_storage_description = /** @type {((inputs?: Settings_Storage_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Storage_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_storage_description(inputs)
	return en_settings_storage_description(inputs)
});
export { settings_storage_description as "settings.storage.description" }